export function addNewUserFormValidator(value) {

    let errors = {};
    if (!value.name) {
        errors.name = 'Name is required';
    }
    if (!value.username) {
        errors.username = 'Username is required';
    }
    if (!value.email) {
        errors.email = 'Email is required';
    }
    if (!value.password) {
        errors.password = 'Password is required';
    }

    return errors;


}